module.exports = "/_next/static/images/ac9f69285abfbc2c5ca17ae928f5a1b8-chedraui-icon.svg.webp";